import {
    Button,
    Stack,
    TextField,
} from "@mui/material";
import { ChangeEvent, useContext, useState } from "react";
import { ErrorDetailContainer } from "../../../api/config";
import { UserDto } from "../../../api/psc";
import { AccountService as IdentityAccountService } from "../../../api/identity";
import { DialogContainer, DialogHeader } from "../../../components/exports";
import ErrorParser from "../../../components/shared/ErrorParser";
import { DialogContext } from "../../../contexts/DialogContext";

export default function UpsertEmployeeDialog(props: {
    user?: UserDto;
}) {
    const { closeDialog } = useContext(DialogContext);

    const [displayName, setDisplayName] = useState(props.user?.displayName ?? "");
    const [mobileNumber, setMobileNumber] = useState(
        props.user?.mobileNumber ?? ""
    );
    const [error, setError] = useState<ErrorDetailContainer | null>(null);
    const [requestInProgres, setRequestInProgress] = useState(false);

    const handleDisplayNameChange = (
        ev: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setDisplayName(ev.target.value);
    };

    const handleMobileNumberChange = (
        ev: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setMobileNumber(ev.target.value);
    };

    const upsert = () => {
        if (props.user) {
            updateUser();
        } else {
            createUser();
        }
    };

    const createUser = () => {
        setRequestInProgress(true);
        IdentityAccountService.addUser({
            mobileNumber,
            displayName,
            claimIds: [],
        })
            .then((r) => {
                closeDialog(true);
            })
            .catch((e) => {
                setError(e);
            })
            .finally(() => {
                setRequestInProgress(false);
            });
    };

    const updateUser = () => {
        if (!props.user?.id) return;
        setRequestInProgress(true);
        IdentityAccountService.updateUser(props.user.id, {
            mobileNumber,
            displayName,
            claimIds: [],
        })
            .then((r) => {
                closeDialog(true);
            })
            .catch((e) => {
                setError(e);
            })
            .finally(() => {
                setRequestInProgress(false);
            });
    };

    return (
        <DialogContainer>
            <DialogHeader title="ایجاد/ویرایش کاربران" />

            <Stack spacing={2} sx={{ p: 2 }}>
                <TextField
                    label="نام نمایشی"
                    value={displayName}
                    variant="outlined"
                    onChange={handleDisplayNameChange}
                />

                <TextField
                    label="شماره موبایل"
                    value={mobileNumber}
                    variant="outlined"
                    onChange={handleMobileNumberChange}
                />

                <ErrorParser error={error} />

                <Button
                    variant="contained"
                    disabled={requestInProgres}
                    onClick={upsert}
                >
                    اعمال تغییرات
                </Button>
            </Stack>
        </DialogContainer>
    );
}
